import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { HomePageService } from 'src/app/Services/home-page.service';
import { StaticPagesService } from 'src/app/Services/static-pages.service';

@Component({
  selector: 'app-all-categories',
  templateUrl: './all-categories.component.html',
  styleUrls: ['./all-categories.component.scss']
})
export class AllCategoriesComponent implements OnInit , AfterViewInit {
        brandsList: any;
    CateSwiperConfig: any = {};
    environmentVariables: any;
    lang: any;
    routerSubscription: any;
    allCategories: any = [];
    arrayList: any[] = [];
    loading: boolean = true;
    headerName: any;
    selectedCategory: any;
    selectedGroup: any;
    fakeArray = new Array(8);
    firstTimeLoaded = true;
    categoriesPage = false;
    showbreadCrumb = false
    allFeaturedCategories:any = [];
    nameRouting: any = [];
    // customCategoriesOptions!: OwlOptions;
    @Input() isSlider : any =  null;
      categoryTypeData = {
       isSlider:'',
       isSqure:'',
    };
    currentPageView:any = ''
    currentPageViewUrl='v2/categories'
  constructor(
      public embryoService: EmbryoService,
        private translate: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private homeData: HomePageService,
        private confgServ: StaticPagesService,
        private cdRef: ChangeDetectorRef
    
    ) { 

this.getInitilizingData();
           embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
         
        });

    }
getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            this.categoryTypeData.isSlider = this.environmentVariables.CATEGORY_STYLE;
            this.categoryTypeData.isSqure = this.environmentVariables.CATEGORY_CARD;
            // console.log(this.categoryTypeData);
            
        });
    }

  ngAfterViewInit(): void {
     this.nameRouting.push({name_en: 'categories', name_ar: 'الفئات'})
                this.homeData.categoriesDataSub.subscribe((data) => {
              if(data.length > 0){
                  this.allCategories = data ;
                  // this.getCategories();
          }
        });
        this.cdRef.detectChanges();
  }

  ngOnInit(): void {
  }



      rediectToProductPage(item:any){
        
        if(this.environmentVariables.MENU_LINK_TYPE === 'slug'){
            if(this.environmentVariables?.ENABLE_CATEGORY_VIEW){
                this.router.navigate([this.lang + "/category/" + item.slug])
            }else{
                this.router.navigate([this.lang + '/product/' + item.slug]);
            }
        }else{
               this.router.navigate(["/" + this.lang + (this.environmentVariables?.    ENABLE_CATEGORY_VIEW ? "/category" : "/products")], {
                   queryParams: {
                     category_id: item.id,
                        },
                      });
          }
     }

}
